import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import { ExperimentStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { MultiItemStore } from 'src/common/stores/multi-item-store';

import { UitkSpacing } from 'uitk-react-spacing';

export interface ToolbarRegionProps extends TemplateComponentProps {
  experiment?: ExperimentStore;
  multiItem?: MultiItemStore;
}

export const ToolbarRegion: React.FC<ToolbarRegionProps> = inject(
  'experiment',
  'multiItem'
)(({ templateComponent }) => {
  const { children } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.masterPage.toolbar">
      <UitkSpacing margin={{ medium: { blockstart: 'two' }, large: { blockstart: 'three' } }}>
        <section>{children && <ExperienceTemplateRenderer templateComponents={children} />}</section>
      </UitkSpacing>
    </ErrorBoundary>
  );
});
